import { render, staticRenderFns } from "./fareSelect.vue?vue&type=template&id=35e3459e&"
import script from "./fareSelect.vue?vue&type=script&lang=js&"
export * from "./fareSelect.vue?vue&type=script&lang=js&"
import style0 from "./fareSelect.vue?vue&type=style&index=0&id=35e3459e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports